import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const CONFIG_API_PATH = '/api/config';

const getBusinessDetails = async () => {
  const response = await axios.get(`${API_BASE_URL}${CONFIG_API_PATH}/business-details`);
  return response.data.data;
};

const getAppConstants = async () => {
  const response = await axios.get(`${API_BASE_URL}${CONFIG_API_PATH}/constants`);
  return response.data.data;
};

const configService = {
  getBusinessDetails,
  getAppConstants, // <-- Add to export  
};

export default configService;
